
import React, { useEffect, useState } from 'react';
import { ActivityIndicator, FlatList, View, ScrollView } from 'react-native';
import Modal from 'modal-enhanced-react-native-web';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Text, TouchableOpacity } from '../../../globalComponents/NativeOverrides';
import Colors from '../../../constants/Colorsv2';
import { useDispatch, useSelector } from 'react-redux';
import { OrderProps } from '../../../store/types/mk_svc';
import { connect } from 'react-redux';
import OrderCard from '../../../Componentsv1/OrderCard';
import { market_getOrderHistoryByPlayerId, market_getOrdersByPlayerId } from '../../../store/actionsv1/markets';
import { V1_LOAD_VIEWING_ORDERS } from '../../../store/actionsv1/types';

type TagOrdersModalProps = {
    isVisible:boolean,
    init_orders:string[]
    closeModal: () => void,
    onTagOrders: (orders:string[]) => void
}

const TagOrdersModal = ({ isVisible, closeModal, onTagOrders, init_orders }:TagOrdersModalProps) => {
    const [ loading, setLoading ] = useState(false);
    const [ active_tab, setActiveTab ] = useState('live');
    const [ selected_orders, setSelectedOrders ] = useState<OrderProps[]>([])
    const dispatch = useDispatch();

    const app_size = useSelector((state:any) => state.util.app_size, (left, right) => left.width === right.width)
    const player = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
    const orders_state:{updated:number, orders:OrderProps[]} = useSelector((state:any) => state.player.orders, (left, right) => left.updated == right.updated)
    let orders = orders_state.orders
    if(active_tab == 'live'){ orders = orders.filter(o => o.resolution_status == 'inprogress') }
    if(active_tab == '7days'){ orders = orders.filter(o => o.resolution_status == 'closed') }
    const insets = useSafeAreaInsets();
    
    useEffect(() => {
        if(!isVisible){ return }
    },[isVisible])

    useEffect(() => {
        getOrdersFromServer(active_tab as 'live' |'7days')
    },[active_tab])
    
    const getOrdersFromServer = async(tab: 'live'|'7days') => {
        if(!player){ return }
        setLoading(true)
        switch(tab){
            case 'live':
                await dispatch(market_getOrdersByPlayerId(player.player_id, 0, true, 'inprogress'))
                break;
            case '7days':
                await dispatch(market_getOrderHistoryByPlayerId(player.player_id, 7))
                break;
            default: break

        }
        setLoading(false)
    }

    const handleCloseModal = () => {
        if(onTagOrders && selected_orders.length > 0){ 
            dispatch({ type: V1_LOAD_VIEWING_ORDERS, orders: selected_orders })
            onTagOrders(selected_orders.map(o => o.order_id)) 
        }
        setSelectedOrders([])
        closeModal()
        return
    }

    const handleSelectOrder = (order:OrderProps) => {
        let exists = selected_orders.find(o => o.order_id == order.order_id)
        if(exists){ return setSelectedOrders(selected_orders.filter(o => o.order_id != order.order_id)) }
        return setSelectedOrders(selected_orders.concat(order))
    }

    const renderOrders = (data: {item:OrderProps, index:number}) => {
        let selected = selected_orders.find(o => o.order_id == data.item.order_id)
        return (
            <TouchableOpacity style={{ margin:5, borderColor:Colors.brand.electric, borderWidth:selected?1:0, borderRadius:4 }} onPress={() => handleSelectOrder(data.item)}>
                <OrderCard view_mode='share' prevent_event_load order={data.item}/>
            </TouchableOpacity>
        )
    }
    return (
        <Modal isVisible={isVisible} coverScreen={true} style={{ flex:1, margin:0, justifyContent: 'flex-end', alignItems:'center'}} animationIn='slideInUp' animationOut='slideOutDown' animationOutTiming={400}
        onSwipeComplete={() => closeModal()} onBackdropPress={() => closeModal()} >
            <View style={{flex:1, width:app_size.width, backgroundColor:Colors.shades.shade200}}>
                <View style={{backgroundColor:Colors.brand.electric, padding:20, paddingTop:insets.top+20}}>
                    <Text color={Colors.shades.white} weight='bold' textAlign='center'>Tag My Orders</Text>
                </View>
                <ScrollView style={{ padding:10 }}>
                    <View style={{flexDirection:'row', marginTop:10, alignItems:'center', backgroundColor:Colors.brand.midnight, padding:4, borderRadius:22, marginLeft:15, marginRight:15, marginBottom:20 }}>
                        <TouchableOpacity style={{flex:1, padding:10, backgroundColor:active_tab==='live'?Colors.brand.midnightTopGradient:'transparent', borderRadius:22}} onPress={() => setActiveTab('live')}>
                            <Text size={14} color={Colors.shades.white} weight='bold' textAlign='center'>ACTIVE</Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={{flex:1, padding:10, backgroundColor:active_tab==='7days'?Colors.brand.midnightTopGradient:'transparent', borderRadius:22}} onPress={() => setActiveTab('7days')}>
                            <Text size={14} color={Colors.shades.white} weight='bold' textAlign='center'>SETTLED LAST 7 DAYS</Text>
                        </TouchableOpacity>
                    </View>
                    <FlatList data={orders} renderItem={renderOrders} keyExtractor={(item) => item.order_id.toString()}/>
                    {loading ?
                    <View style={{ justifyContent:'center', alignItems:'center', padding:20 }}>
                        <ActivityIndicator size='large' color={Colors.brand.midnight} />
                    </View>
                    :<></>}
                </ScrollView>
                <TouchableOpacity style={{ margin:10, borderWidth:1, borderColor:Colors.brand.midnight, borderRadius:4, padding:5 }} onPress={() => handleCloseModal()}>
                    <Text style={{ padding:5 }} size={14} color={Colors.brand.midnight} weight='regular' textAlign='center'>{selected_orders.length > 0? `Tag ${selected_orders.length} Orders`: "Close"}</Text>
                </TouchableOpacity>
            </View>
        </Modal>
    )
}

const areEqual = (prevProps:TagOrdersModalProps, nextProps:TagOrdersModalProps) => {
    if(prevProps.isVisible !== nextProps.isVisible){ return false }
    return true
}

export default React.memo(TagOrdersModal, areEqual)